
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import { AngularMaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientViewComponent } from './client-view/client-view.component';
import { ClickOutsideModule } from 'ng-click-outside';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ClientFormComponent } from './client-form/client-form.component';
import { ClientEditComponent } from './client-edit/client-edit.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PreviousRouteService } from 'src/app/shared/services/previous-route.service';

export const baseRoutes: Routes = [
  {
    path: '',
    component: ClientViewComponent,
    data: {
      title: 'Client'
    },
  },
  {
    path: 'add',
    component: ClientFormComponent,
    data: {
      title: 'Client'
    },
  },
  {
    path: 'edit/:id',
    component: ClientFormComponent,
    data: {
      title: 'Client'
    },
  }
];

@NgModule({
  imports: [
    CommonModule,FormsModule,ReactiveFormsModule,ClickOutsideModule,
    AngularMaterialModule,MatNativeDateModule,MatAutocompleteModule,
    RouterModule.forChild(baseRoutes),
    NgxMatSelectSearchModule
  ],
  declarations: [ClientViewComponent, ClientFormComponent,ClientEditComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
    PreviousRouteService
  ]
})
export class ClientModule { }
